import apiClient from './client'
import type { User, CreateUserRequest } from '@shared/types/api'

export const updateSelectedOrganization = async (userId: string, organizationId: string | null): Promise<void> => {
  await apiClient.put(`/users/${userId}/selected-organization`, {
    selected_organization_id: organizationId,
  })
}

export const usersApi = {
  // POST /api/v1/users - регистрация пользователя
  register: async (data: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post<User>('/users', data)
    return response.data
  },

  // GET /api/v1/users/me - вошедший пользователь (мини-приложение MAX, веб)
  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/users/me')
    return response.data
  },

  // GET /api/v1/users/{id} - получить пользователя
  getById: async (id: string): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${id}`)
    return response.data
  },

  // PUT /api/v1/users/{id} - обновить профиль
  update: async (id: string, data: Partial<User>): Promise<User> => {
    const response = await apiClient.put<User>(`/users/${id}`, data)
    return response.data
  },

  // GET /api/v1/users/{id}/subscription - информация о подписке
  getSubscription: async (id: string): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${id}/subscription`)
    return response.data
  },

  // PUT /api/v1/users/{id}/selected-organization - обновить выбранную организацию
  updateSelectedOrganization: async (id: string, organizationId: string | null): Promise<void> => {
    await apiClient.put(`/users/${id}/selected-organization`, {
      selected_organization_id: organizationId,
    })
  },

  // DELETE /api/v1/users/{id} - удалить пользователя
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`)
  },
}
